import React from "react";
import {
  LayoutDashboard,
  Swords,
  Medal,
  Share2,
  Users,
  Receipt,
  Landmark,
  MessageSquare,
  Trophy,
  Cog,
  Sparkles,
} from "lucide-react";

const ICON_MAP = {
  overview: LayoutDashboard,
  p2p: Swords,
  predictions: Sparkles,
  leaderboard: Medal,
  referrals: Share2,
  "chat-moderation": MessageSquare,
  users: Users,
  transaction: Receipt,
  transactions: Receipt,
  treasury: Landmark,
  leagues: Trophy,
  system: Cog,
};

export default function NavIcon({ id, size = 16, strokeWidth = 2.2 }) {
  const Icon = ICON_MAP[id] || LayoutDashboard;
  return <Icon size={size} strokeWidth={strokeWidth} aria-hidden />;
}
